import React from 'react';
import Layout from '../components/Layout/Layout';

export default function PageNotFound() {
    return <div>Page Not Found</div>;
}
